export default {"src":"/login-app/[GIT_HASH]/_next/static/media/scim_provision.561b3185.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};